import styled from 'styled-components'
import { SpecialButton } from '@chegg-wt/core/theme/fanta/button'
import { colors, spacing, font } from '@chegg-ui/theme'
import { themeBreakPoints } from '@chegg-wt/core/theme/theme'
import { AspiraStack } from '@chegg-wt/core/theme/fanta/fonts'

export const Box = styled.div.attrs({
  role: 'region',
  'aria-label': 'Create Account Banner',
})`
  display: flex;
  border: 1px solid ${colors.greyXlight};
  background-color: ${colors.skyLight};
  height: 94px;
`
export const Container = styled.div`
  @media (max-width: ${({ theme }) => themeBreakPoints.small(theme)}) {
    height: 80px;
  }
`

export const KeepCitations = styled.p`
  font-size: ${font.size.px24};
  height: ${spacing.px24};
  font-weight: ${font.weight.bold};
  margin-top: ${spacing.px24};
  margin-left: ${spacing.px24};
  margin-bottom: ${spacing.px4};
  @media (max-width: ${({ theme }) => themeBreakPoints.medium(theme)}) {
    font-size: ${font.size.px20};
  }
  @media (max-width: ${({ theme }) => themeBreakPoints.small(theme)}) {
    margin-left: ${spacing.px16};
    font-size: ${font.size.px14};
    line-height: 0.8;
  }
`
export const CreateAccount = styled.p`
  ${AspiraStack};
  font-weight: ${font.weight.medium};
  font-size: ${font.size.px14};
  height: 18px;
  margin-bottom: ${spacing.px24};
  margin-left: ${spacing.px24};
  @media (max-width: ${({ theme }) => themeBreakPoints.small(theme)}) {
    margin-left: ${spacing.px16};
    line-height: 1;
  }
  @media (max-width: ${({ theme }) => themeBreakPoints.extraSmall(theme)}) {
    margin-top: ${spacing.px12};
    font-size: ${font.size.px12};
  }
`
export const CreateButton = styled(SpecialButton)`
  margin: 27px 24px 27px auto !important;
  height: 44px;
  @media (max-width: ${({ theme }) => themeBreakPoints.small(theme)}) {
    font-size: ${font.size.px14} !important;
    line-height: initial;
  }
`
